<template>
  <NuxtLayout
    name="generic"
    header="standardDark"
    footer="standard"
  >
    <template v-if="page">
      <div
        :class="{
          'blog-template mt-70px bg-www-color-neutral-off-white md:mt-120px': true,
          'max-md:[&>p.content]:text-sm': true,
        }"
      >
        <EventPageHero :page="page" />
        <ResourceCenterLoader v-if="isFirstLoad" />
        <ClientOnly>
          <EventsCenterLayout
            v-model:is-first-load="isFirstLoad"
            :page="page"
          />
        </ClientOnly>
      </div>
    </template>
  </NuxtLayout>
</template>

<script lang="ts" setup>
import ResourceCenterLoader from '~/components/Atmos/ResourceCenterLoader/ResourceCenterLoader.vue';
import EventPageHero from '~/components/Organisms/EventsCenterLayout/EventPageHero.vue';
import EventsCenterLayout from '~/components/Organisms/EventsCenterLayout/EventsCenterLayout.vue';
import { pageResourceCenterEventsIndex } from '~/queries/pages/PageResourceCenterEventsIndex.query';
import type { PageResourceCenterEventsIndexResult } from '~/sanity/types';

let { path: currentPathname } = useRoute();
// Ensure the pathname ends with a trailing slash for consistency
// This is important because the Sanity query expects the pathname to have a trailing slash, and it may not match if it doesn't.
// TODO: Check other similar pages to see if they also need this fix, and if so, consider creating a utility function to handle this consistently across the app.
if (!currentPathname.endsWith('/')) {
  currentPathname += '/';
}
const isFirstLoad = ref(true);
const { data: page } = await useWwwSanityQueryNonNull<PageResourceCenterEventsIndexResult>(
  pageResourceCenterEventsIndex,
  {
    currentPathname,
  }
);

if (page.value.heroImage?.asset?._ref) {
  preloadImgSrc(cdnImage(page.value.heroImage.asset._ref).bg);
}
usePageHead({
  _id: page.value?._id,
  description: page.value.ogDescription || page.value?.description,
  ogImage:
    page.value.ogImage?.asset || page.value?.cardImage?.asset || page.value?.heroImage?.asset,
  excludeFromExternalSearch: page.value?.excludeFromExternalSearch,
  title: page.value?.htmlTitle || page.value?.title,
  twitterCard: 'summary',
});
</script>

<style></style>
